import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const FormaterID = (props) => {
      const { value } = props
      if (value !== null && typeof value  === 'number') 
        return <div style={{ textAlign: props.Align, color: props.Color }} title={value}>{value}</div>;
      else 
        return <div title={value}>
           <img style={{marginTop:0}} src={props.Src} width={props.Width} height={props.Height} />
        </div>
  }

  export default FormaterID;  